import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { catalogCardSx } from "./catalogStyles";

interface CatalogCardProps {
  title: string;
  heading?: "h2" | "h3";
  description?: string;
  image?: string;
  tags: string[];
  to: string;
  testId: string;
}

export function CatalogCard({
  title,
  heading = "h3",
  description,
  image,
  tags,
  to,
  testId
}: CatalogCardProps) {
  return (
    <Box
      component={Link}
      to={to}
      data-testid={testId}
      className="site-motion"
      sx={(theme) => ({
        ...catalogCardSx(theme),
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      })}
    >
      <Box
        sx={{
          aspectRatio: "16 / 9",
          bgcolor: "#101018",
          position: "relative",
          flexShrink: 0,
          borderBottom: 1,
          borderColor: "divider"
        }}
      >
        {image && (
          <Box
            component="img"
            src={image}
            alt=""
            loading="lazy"
            sx={{
              position: "absolute",
              inset: 12,
              width: "calc(100% - 24px)",
              height: "calc(100% - 24px)",
              objectFit: "contain"
            }}
          />
        )}
      </Box>
      <Box
        sx={{
          p: 2.5,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          gap: 1.25
        }}
      >
        <Typography component={heading} variant="h6">
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            gap: 0.75,
            flexWrap: "wrap",
            mt: "auto",
            pt: 1
          }}
        >
          {tags.map((tag, index) => (
            <Box
              key={`${tag}-${index}`}
              component="span"
              sx={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: "0.75rem",
                color: index === 0 ? "tagLangColor" : "tagColor",
                bgcolor: index === 0 ? "tagLangBg" : "tagBg",
                px: 1,
                py: 0.375,
                borderRadius: "4px"
              }}
            >
              {tag}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
